import React from "react";
import PrivateRoute from "components/private-route";
import SubscriptionDetails from "components/account/subscription";
import AccountProfileLayout from "layouts/account-profile";
import { useSelector } from "react-redux";
import { useFairing } from "hooks/useFairing";
import extractId from "helpers/extract-gid";
import { FAIRING_API_KEY } from "utils/constants";
import { CURRENT_COUNTRY } from "utils/constants";

export { Head } from "components/head";

const SubscriptionPage = ({ pageContext, location }) => {
	const { modules, cancelledModules, header, footer, products, _type, headerImage, pageSettings } = pageContext;
	const { isFetched, status } = useSelector(state => state.account.subscription);
	const { id, emailAddress, orders } = useSelector(state => state.account.profile);
	const customerId = extractId(id) ?? null;
	const latestOrder = orders.data.find((order) => order.isSubscription) ?? orders.data[0] ?? null;
	const latestOrderId = extractId(latestOrder?.id) ?? null;
	const latestOrderNumber = latestOrder?.name?.replace(/^#/, "") ?? null;
	const validProducts = Array.isArray(products) ? products.filter((product) => product?.variant?.id) : [];


	useFairing({
		apiKey: FAIRING_API_KEY,
		customerId,
		customerEmail: emailAddress?.emailAddress ?? null,
		orderCount: orders.numberOfOrders ?? null,
		orderId: latestOrderId,
		orderNumber: latestOrderNumber,
		orderCreatedAt: latestOrder?.processedAt ?? latestOrder?.createdAt ?? null,
		enabled: CURRENT_COUNTRY === "de" && Boolean(customerId && latestOrderId),
	});

	return (
		<AccountProfileLayout
			_type={_type}
			path={location.pathname}
			header={header}
			footer={footer}
			headerImage={status !== "CANCELLED" && headerImage}
			pageSettings={pageSettings}
		>
			<PrivateRoute
				path={location.pathname}
				component={SubscriptionDetails}
				products={validProducts}
				modules={modules}
				cancelledModules={cancelledModules}
				showLoader={!isFetched}
			/>
		</AccountProfileLayout>
	);
};

export default SubscriptionPage;
